const creditPackPreviousPrice = {
  quantity: {
    label: "Quantité",
    invalid: {}
  },
  quantityFree: {
    label: "Quantité offerte",
    invalid: {}
  },
  price: {
    label: "Prix",
    invalid: {}
  },
  modifiedAt: {
    label: "Date",
    invalid: {}
  },
};

export default creditPackPreviousPrice;
